import { toast } from "react-toastify"


export function rndFromArray(a)
{
    return a[0|Math.random() * a.length]
}

const ERROR_OPTIONS = {type: "error", autoClose: 1500, align: "center"}


/**
 * Standard method to display user-facing errors with toast.
 *
 * @param message       error message
 * @return {*} toast id
 */
export function displayError(message)
{
    return toast(message, ERROR_OPTIONS);
}


/**
 * Removes a trailing non-null exclamation mark from a type name if it is present.
 *
 * @param t     type expression
 * @return {string} type name without trailing exclamation mark
 */
export function unwrapNonNullTypeName(t)
{
    const last = t.length - 1
    return t.substring(last) === "!" ? t.substring(0, last) : t
}


/**
 * Returns true if the given type definition is a NON_NULL type.
 *
 * @param t
 * @return {boolean}
 */
export function isNonNull(t)
{
    return t.kind === "NON_NULL"
}


/**
 * Returns the wrapped type if the given type definition is a NON_NULL type otherwise it returns
 * the type as-is.
 *
 * @param t     type definition
 * @return {object} unwrapped type definition
 */
export function unwrapNonNull(t)
{
    if (isNonNull(t))
    {
        return t.ofType
    }
    return t
}
